import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { isLogin } from '../utils/session';
import AppLayout from '../components/AppLayout';
import { EnrollmentContext } from '../providers/EnrollmentContextProvider';
import FigureType from '../enums/FigureType';

const RouteWrapper = ({ component: Component, path, restricted, isPublic, title }) => {
  // Window's title
  window.document.title = title ? `${title} | Vantrust Capital` : 'Vantrust Capital';

  const { figureType } = useContext(EnrollmentContext);

  if (isPublic) {
    return isLogin() && restricted && figureType === FigureType.NATURAL ? (
      <Redirect to="/enrolamiento/formulario" />
    ) : (
      <Route
        path={path}
        render={(props) => (
          <AppLayout {...props}>
            <Component {...props} />
          </AppLayout>
        )}
      />
    );
  }

  if (isLogin()) {
    return (
      <Route
        path={path}
        render={(props) => (
          <AppLayout {...props}>
            <Component {...props} />
          </AppLayout>
        )}
      />
    );
  }

  return <Redirect to="/enrolamiento/inicio" />;
};

RouteWrapper.defaultProps = {
  restricted: false,
  isPublic: false,
};

RouteWrapper.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  restricted: PropTypes.bool,
  isPublic: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default RouteWrapper;
